import React from "react";
import classNames from "../../classNames";

const noop = () => {};
const defaultProps = {
  type: "text",
  strict: false,
  onChange: noop,
};

function InputString({ className, strict, onChange, uppercase, ...props }) {
  function onInput(e) {
    let value = e.target.value.normalize("NFC");
    const character = value.charAt(value.length - 1);

    if (strict && !/^[a-zA-Z]*$/.test(character)) {
      return;
    }

    if (uppercase) {
      const start = e.target.selectionStart; // 1. save
      e.target.value = value.toUpperCase(); // 2. mutate (cursor jumps to end)
      e.target.setSelectionRange(start, start); // 3. restore
      value = e.target.value;
    }

    onChange(value);
  }

  return (
    <input
      className={classNames("form-control", className)}
      onInput={onInput}
      {...props}
    />
  );
}

InputString.defaultProps = defaultProps;
export default InputString;
